import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaperOtpComponent } from './components/paper-otp.component';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { KeysPipe } from './pipes/keys.pipe';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    declarations: [PaperOtpComponent, KeysPipe, NumberOnlyDirective],
    exports: [PaperOtpComponent, KeysPipe, NumberOnlyDirective],
    providers: [KeysPipe],
})
export class PaperOtpModule {}
